import { render, staticRenderFns } from "./LeaderboardCard.vue?vue&type=template&id=d071f3c0&scoped=true"
import script from "./LeaderboardCard.vue?vue&type=script&lang=js"
export * from "./LeaderboardCard.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardCard.vue?vue&type=style&index=0&id=d071f3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d071f3c0",
  null
  
)

export default component.exports